
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.642 19.824a.932.932 0 01-.919-.83L5.915 7.403h-.818a.553.553 0 01-.553-.553.553.553 0 01.553-.553H9.05v-1.2a.923.923 0 01.922-.922h4.057a.924.924 0 01.923.922v1.2h3.951a.553.553 0 01.553.553.554.554 0 01-.553.553h-.819l-1.807 11.584a.933.933 0 01-.92.837zm.167-1.107h6.379l1.776-11.314H7.033zm5.034-12.421V5.281h-3.689v1.015z","fill":"inherit"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}})])
          )
        }
      }
    